import { render } from "./DeleteCategoryDialog.vue?vue&type=template&id=06b44175"
import script from "./DeleteCategoryDialog.vue?vue&type=script&lang=js"
export * from "./DeleteCategoryDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__